import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageDropdown.css';

const LanguageDropdown = forwardRef(({ onDropdownOpen }, ref) => {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'en', name: t('language.english'), flag: '🇺🇸' },
    { code: 'de', name: t('language.german'), flag: '🇩🇪' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  // Expose methods to parent component
  useImperativeHandle(ref, () => ({
    closeDropdown: () => {
      setIsOpen(false);
    }
  }));

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    const newIsOpen = !isOpen;
    setIsOpen(newIsOpen);
    
    // Notify parent when dropdown opens
    if (newIsOpen && onDropdownOpen) {
      onDropdownOpen();
    }
  };

  return (
    <div className="language-dropdown">
      <button 
        className="language-dropdown-trigger"
        onClick={toggleDropdown}
        aria-label="Select language"
      >
        <span className="language-code">{currentLanguage.code.toUpperCase()}</span>
      </button>

      {isOpen && (
        <>
          <div className="language-dropdown-overlay" onClick={() => setIsOpen(false)} />
          <div className="language-dropdown-menu">
            {languages.map((language) => (
              <button
                key={language.code}
                className={`language-dropdown-item ${i18n.language === language.code ? 'active' : ''}`}
                onClick={() => handleLanguageChange(language.code)}
              >
                <span className="language-flag">{language.flag}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
});

LanguageDropdown.displayName = 'LanguageDropdown';

export default LanguageDropdown;